function Breadcrumbs(title, url, show) {
    
    //Parameter Cleansing
    show = (typeof (show) === "undefined") ? true : show;
    title = (typeof (title) === "undefined") ? "" : title;
    url = (typeof (url) === "undefined") ? null : url;

    var self = this;

    // Public Variables
    self.root = "My Computers";

    // Observables
    self.title = ko.observable(title);
    self.url = ko.observable(url);
    self.show = ko.observable(show);

    // Subscribes
    self.title.subscribe(function() {
        if (self.title()) {
            self.show(true);
        }
        else {
            self.show(false);
        }
    });
}